<template>
    <div
        class="host kgr-inputGroup"
        :class="{'kgr-inputGroup--inline': inline}"
    >
        <div
            v-if="label !== null"
            class="kgr-inputGroup__label ui-droppable"
            @click="active = true"
        >
            {{ label }}
        </div>
        <input
            v-model="view"
            type="text"
            :disabled="disabled"
            class="kgr-input"
            :class="{ 'is-invalid': hasError }"
            @click="active = true"
            @input="updateValue($event.target.value)"
        />
        <div
            v-show="active"
            class="selection"
        >
            <div class="year">
                <div
                    v-if="selectedYear > 1000"
                    class="year_selection"
                    @click="decrementYear()"
                >
                    <template><</template>
                </div>
                <div v-else></div>
                <div>{{ selectedYear }}</div>
                <div
                    v-if="selectedYear < 9999 && (!maxYear || selectedYear < maxYear)"
                    class="year_selection"
                    @click="incrementYear()"
                >
                    <template>></template>
                </div>
                <div v-else></div>
            </div>
            <div class="months">
                <div class="row">
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 1, disabled: monthDisabled(1) }"
                        @click="selectMonth(1)"
                    >
                        Jan
                    </div>
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 2, disabled: monthDisabled(2) }"
                        @click="selectMonth(2)"
                    >
                        Feb
                    </div>
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 3, disabled: monthDisabled(3) }"
                        @click="selectMonth(3)"
                    >
                        Mär
                    </div>
                </div>
                <div class="row">
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 4, disabled: monthDisabled(4) }"
                        @click="selectMonth(4)"
                    >
                        Apr
                    </div>
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 5, disabled: monthDisabled(5) }"
                        @click="selectMonth(5)"
                    >
                        Mai
                    </div>
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 6, disabled: monthDisabled(6) }"
                        @click="selectMonth(6)"
                    >
                        Jun
                    </div>
                </div>
                <div class="row">
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 7, disabled: monthDisabled(7) }"
                        @click="selectMonth(7)"
                    >
                        Jul
                    </div>
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 8, disabled: monthDisabled(8) }"
                        @click="selectMonth(8)"
                    >
                        Aug
                    </div>
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 9, disabled: monthDisabled(9) }"
                        @click="selectMonth(9)"
                    >
                        Sep
                    </div>
                </div>
                <div class="row">
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 10, disabled: monthDisabled(10) }"
                        @click="selectMonth(10)"
                    >
                        Okt
                    </div>
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 11, disabled: monthDisabled(11) }"
                        @click="selectMonth(11)"
                    >
                        Nov
                    </div>
                    <div
                        class="cell"
                        :class="{ active: selectedMonth === 12, disabled: monthDisabled(12) }"
                        @click="selectMonth(12)"
                    >
                        Dez
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="error != null"
            class="kgr-color kgr-color--error"
        >
            {{ error }}<br />
        </div>
    </div>
</template>

<script>
import MonthOfYear from '../../../../js/date/MonthOfYear.js';

export default {
    props: {
        month: {
            type: Number,
            required: false,
            example: 10,
        },
        year: {
            type: Number,
            required: false,
            example: 2018,
        },
        maxMonth: {
            type: Number,
            required: false,
            example: 12,
        },
        label: {
            type: String,
            required: false,
            default: 'Monat',
        },
        maxYear: {
            type: Number,
            required: false,
            example: 2025,
        },
        inline: {
            type: Boolean,
            required: false,
            example: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: String,
            required: false,
            default: null
        },
    },
    data() {
        return {
            active: false,
            hasError: false,
            months: {
                1: 'Januar',
                2: 'Februar',
                3: 'März',
                4: 'April',
                5: 'Mai',
                6: 'Juni',
                7: 'Juli',
                8: 'August',
                9: 'September',
                10: 'Oktober',
                11: 'November',
                12: 'Dezember',
            },
            selectedMonth: null,
            selectedYear: null,
            view: null,
        }
    },
    watch: {
        year(year) {
            this.selectedYear = year;
            this.resetView();
        },
        month(month) {
            this.selectedMonth = month;
            this.resetView();
        },
    },
    created() {
        this.selectedMonth = this.month ? this.month : new Date().getMonth() + 1;
        this.selectedYear = this.year ? this.year : new Date().getFullYear();

        if (this.maxMonth && this.selectedMonth > this.maxMonth && (!this.maxYear || this.selectedYear >= this.maxYear)) {
            this.selectedMonth = this.maxMonth;
        }

        if (this.maxYear && this.selectedYear > this.maxYear) {
            this.selectedYear = this.maxYear;
        }

        this.resetView();

        document.addEventListener('click', event => {
            if (this.$el !== event.target && !this.$el.contains(event.target)) {
                this.active = false;
            }
        })
    },
    mounted() {
        this.change();
    },
    methods: {
        change() {
            if (this.hasError) {
                return;
            }
            this.$emit('change', {
                month: +this.selectedMonth,
                year: +this.selectedYear,
            });
            this.$emit('monthOfYear', new MonthOfYear(
                this.selectedMonth,
                this.selectedYear,
            ));
        },
        selectMonth(month) {
            if(this.monthDisabled(month)){
                return;
            }

            this.selectedMonth = month;
            this.hasError = false;
            this.active = false;
            this.resetView();
            this.change();
        },
        updateValue(text) {
            let elements = text.split(' ');
            if (elements.length !== 2) {
                this.hasError = true;
                return;
            }

            let month = -1;
            for (let i = 1; i <= 12; i++) {
                if (this.months[i] === elements[0]) {
                    month = i;
                }
            }
            if (month === -1) {
                this.hasError = true;
                return;
            }

            if (this.maxMonth && month > this.maxMonth) {
                this.hasError = true;
                return;
            }

            let year = +elements[1];
            if (isNaN(year) || year < 1000 || year >= 10000) {
                this.hasError = true;
                return;
            }

            if (this.maxYear && year > this.maxYear) {
                this.hasError = true;
                return;
            }

            this.hasError = false;
            this.selectedMonth = month;
            this.selectedYear = year;
            this.change();
        },
        incrementYear() {
            if (this.selectedYear < 9999) {
                this.selectedYear++;
            }
        },
        decrementYear() {
            if (this.selectedYear > 1000) {
                this.selectedYear--;
            }
        },
        resetView() {
            this.view = this.months[this.selectedMonth] + ' ' + this.selectedYear;
        },
        monthDisabled(month) {
            if (this.maxMonth) {
                if (this.maxYear) {
                    return this.selectedYear >= this.maxYear && this.maxMonth < month;
                } else {
                    return this.maxMonth < month;
                }
            }

            return false;
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.host {
    position: relative;
    input {
        text-align: center;
    }
    .selection {
        position: absolute;
        left: -1px;
        top: 100%;
        width: 100%;
        border: 1px solid #ccc;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        box-shadow: inset -1px 1px 1px 1px #f1f1f1;
        background-color: #fff;
        z-index: 1000;
    }
    &.active {
        border-bottom-right-radius: 0;
    }
    .year {
        display: flex;
        padding: 8px 8px 0;
        div {
            flex-grow: 1;
            text-align: center;
            font-weight: var(--kgr-font-weight-bold);
            padding: 4px;
            &.year_selection {
                cursor: pointer;
                &:hover {
                    background-color: #ccc;
                }
            }
        }
    }
    .months {
        padding: 8px;
        .row {
            display: flex;
            .cell {
                cursor: pointer;
                padding: 4px;
                flex-grow: 1;
                flex-basis: 33%;
                text-align: center;
                &:hover {
                    background-color: #ccc;
                }
                &.active {
                    background-color: var(--kgr-color-accent);
                    color: var(--kgr-color-accent-inverted);
                }
                &.disabled {
                    cursor: auto;
                    color: #d6d6d6;
                    &:hover {
                        background: #fff;
                    }
                }
            }
        }
    }
}
</style>
